<template>
  <div>
    <div class="main-title">车辆租赁管理</div>
    <div class="main-content">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" @submit.native.prevent :model="searchForm">
          <el-form-item>
            <el-select
              v-model="searchForm.company_ids"
              multiple
              placeholder="选择科目"
              @change="search(searchForm)"
              style="width:250px;">
              <el-option
                v-for="item in companyList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="搜索车牌号或编号"
              v-model="searchForm.query"
              clearable
              prefix-icon="el-icon-search"
              @input="inputSearch(searchForm)">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-tooltip class="item" effect="dark" :content="'现金:' + todayTotal.cash + ',支付宝:' + todayTotal.alipay + ',微信:' + todayTotal.wechat + ',充值卡:' + todayTotal.balance + ',代金券:' + todayTotal.coupon + ',挂账:' + todayTotal.virtual" placement="top">
              <el-button type="text" @click="gotoReportOper">今日累计收入:{{ todayTotal.total }}元</el-button>
            </el-tooltip>
          </el-form-item>
          <el-form-item>
            当前押金:{{ totalYajing }}元
          </el-form-item>
        </el-form>
        <el-button icon="el-icon-refresh" @click="refresh" :loading="loading" size="small">刷新</el-button>
      </div>
      <!-- 批量操作按钮 -->
      <div class="batch-buttons" v-show="showBatchButtons">
        <el-dropdown v-if="batchStatus === '闲置'" @command="batStart" :loading="batStarting">
          <el-button type="primary">
            开始用车({{ selectRows.length }}台车)<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="考试">考试</el-dropdown-item>
            <el-dropdown-item command="牵车">牵车</el-dropdown-item>
            <el-dropdown-item command="试车">试车</el-dropdown-item>
            <el-dropdown-item command="热车">热车</el-dropdown-item>
            <el-dropdown-item command="加油">加油</el-dropdown-item>
            <el-dropdown-item command="维修">维修</el-dropdown-item>
            <el-dropdown-item command="洗车">洗车</el-dropdown-item>
            <el-dropdown-item command="培训">培训</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-button type="danger" v-else @click="batEnd" :loading="batEnding">结束{{ batchStatus }}({{ selectRows.length }}台车)</el-button>
      </div>
      <!-- 列表 -->
      <el-table
        ref="chargeList"
        :data="list"
        stripe
        border
        :height="tableHeight"
        style="width:100%"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
        row-key="id">
        <el-table-column
          reserve-selection
          type="selection">
        </el-table-column>
        <el-table-column
          prop="company_name"
          label="所属科目"
          fixed
          width="100">
        </el-table-column>
        <el-table-column
          prop="car_alias"
          label="车辆编号"
          fixed
          width="124">
        </el-table-column>
        <el-table-column
          prop="licnum"
          label="车牌号"
          fixed
          width="100">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          width="70"
          fixed
          :filters="statusFilters"
          :filter-method="filterStatus"
          filter-placement="bottom-end">
        </el-table-column>
        <el-table-column
          label="操作"
          fixed
          width="80">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '闲置'" type="text" @click="start(scope.row)">开始用车</el-button>
            <el-button v-else type="text" style="color:#f56c6c;" @click="stop(scope.row)">结束用车</el-button>
          </template>
        </el-table-column>
        <el-table-column
          label="打印"
          width="60">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '训练'" type="text" @click="printUse(scope.row)">打印</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="secu_name"
          label="安全员"
          width="80">
        </el-table-column>
        <el-table-column
          prop="coach_name"
          label="用车人"
          width="160">
        </el-table-column>
        <el-table-column
          label="车上学员"
          width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status === '训练'" type="text" @click="showStudent(scope.row)">{{scope.row.student_count}}个学员</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="curr_price_type"
          label="计费方式"
          width="100">
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          width="60">
        </el-table-column>
        <el-table-column
          prop="start_time"
          label="开始时间"
          width="160">
        </el-table-column>
        <el-table-column
          prop="use_time"
          label="时长"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.use_time && scope.row.use_time < 1440">{{ scope.row.use_time }}分钟</span>
            <span v-if="scope.row.use_time && scope.row.use_time >= 1440">{{ parseInt(scope.row.use_time / 1440) }}天</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="fee"
          label="费用"
          width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.use_time">{{ scope.row.fee }}元</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="min_fee"
          label="保底消费"
          width="80">
        </el-table-column>
        <el-table-column
          prop="yajing"
          label="押金"
          width="80">
        </el-table-column>
        <el-table-column
          prop="route_name"
          label="训练路线"
          width="80">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="培训服务"
          width="80"
          v-if="[1,10].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="exam_service"
          label="类型"
          width="80"
          v-if="[32].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="sales_name"
          label="业务员"
          width="70"
          v-if="[1,10].indexOf(user.group_id) >= 0">
        </el-table-column>
        <el-table-column
          prop="oper_name"
          label="操作员"
          width="70">
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注"
          width="150">
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total"
        :total="total">
      </el-pagination>
    </div>
    <!-- 开始用车表单 -->
    <el-dialog :title="startFormTitle" :visible.sync="startFormVisible">
      <el-form :model="startForm" ref="startForm" class="start-form" :rules="startFormRules" label-width="200px">
        <el-form-item label="用车类型">
          <el-select v-model="startForm.status">
            <el-option label="训练" value="训练"></el-option>
            <el-option label="考试" value="考试"></el-option>
            <el-option label="牵车" value="牵车"></el-option>
            <el-option label="试车" value="试车"></el-option>
            <el-option label="热车" value="热车"></el-option>
            <el-option label="加油" value="加油"></el-option>
            <el-option label="维修" value="维修"></el-option>
            <el-option label="洗车" value="洗车"></el-option>
            <el-option label="培训" value="培训"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="安全员" prop="secu_id" v-if="startForm.status == '训练'">
          <el-select
            v-model="startForm.secu_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入安全员姓名或拼音"
            :remote-method="searchSecu"
            :loading="secuLoading">
            <el-option
              v-for="item in secuListFilter"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用车人 / 教练" prop="coach_id" v-if="startForm.status == '训练'">
          <el-col :span="12">
            <el-select
              v-model="startForm.coach_id"
              filterable
              remote
              reserve-keyword
              placeholder="输入教练姓名或拼音"
              :remote-method="searchCoach"
              :loading="coachLoading">
              <el-option
                v-for="item in coachList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12">
            <el-button type="text" @click="addCoach">添加新教练</el-button>
          </el-col>
        </el-form-item>
        <el-form-item label="计费套餐" v-if="startForm.status == '训练' && feePackageListFilter.length > 0">
          <el-select v-model="startForm.fee_package_id" @change="feePackageChange" filterable>
            <el-option :label="defFeeLabel" :value="0"></el-option>
            <el-option v-for="item in feePackageList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <span v-if="startForm.fee_package_id > 0 && selectedPackage.type != '按分钟计费'" style="font-size:20px;">×</span>
          <el-input-number v-if="startForm.fee_package_id > 0 && selectedPackage.type != '按分钟计费'" v-model="startForm.fee_package_count" @change="feePackageCountChange" :min="1" :max="20" style="width:120px"></el-input-number>
        </el-form-item>
        <el-form-item label="保底消费" prop="min_fee" v-if="startForm.status == '训练' && (startForm.fee_package_id <= 0 || selectedPackage.type == '按分钟计费')">
          <el-input-number v-model.number="startForm.min_fee" :min="0" :max="5000" :step="100" style="width:140px;"></el-input-number>
        </el-form-item>
        <el-form-item label="固定消费" v-if="startForm.status == '训练' && startForm.fee_package_id > 0 && selectedPackage.type != '按分钟计费'">
          <span style="color:green;font-weight:bold;">{{ startForm.fee }}</span> 元
        </el-form-item>
        <el-form-item label="自动结束" v-if="startForm.status == '训练' && startForm.fee_package_id > 0 && selectedPackage.type != '按分钟计费'">
          <el-input-number v-model.number="startForm.auto_stop_minutes" :min="1" :max="10000" style="width:160px;"></el-input-number>
          <span style="margin-left:8px;">分钟后自动结束</span>
        </el-form-item>
        <el-form-item label="付费模式" v-if="startForm.status == '训练' && startForm.fee_package_id > 0 && selectedPackage.type != '按分钟计费'">
          <el-select v-model="startForm.is_prepaid" style="width:140px;">
            <el-option label="后付费" value="0"></el-option>
            <el-option label="先付费" value="1"></el-option>
          </el-select>
          <span v-if="startForm.is_prepaid === '1'" style="font-size:12px;color:#999;">&nbsp;*点击确定用车后将生成账单并付款</span>
        </el-form-item>
        <el-form-item label="押金" prop="yajing" v-if="startForm.status == '训练' && startForm.is_prepaid !== '1'">
          <el-input-number v-model.number="startForm.yajing" :min="0" :max="5000" :step="100" style="width:140px;"></el-input-number>
        </el-form-item>
        <el-form-item label="自动结束" v-if="startForm.status == '训练' && (startForm.fee_package_id <= 0 || selectedPackage.type == '按分钟计费')">
          <el-switch v-model="autoStop"></el-switch>
        </el-form-item>
        <el-form-item v-if="autoStop && startForm.status == '训练' && (startForm.fee_package_id <= 0 || selectedPackage.type == '按分钟计费')">
          <el-input v-model.number="startForm.auto_stop_minutes" style="width:310px">
            <template slot="prepend">在</template>
            <template slot="append">分钟后自动结束(<span style="color:green;">{{ autoStopFee }}</span>元)</template>
          </el-input>
        </el-form-item>
        <el-form-item label="训练路线" v-if="startForm.status == '训练'">
          <el-select v-model="startForm.route_name" style="width:140px;">
            <el-option label="路线1" value="路线1"></el-option>
            <el-option label="路线2" value="路线2"></el-option>
            <el-option label="路线3" value="路线3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="培训服务" v-if="startForm.status == '训练' && [1,10].indexOf(user.group_id) >= 0">
          <el-select v-model="startForm.exam_service">
            <el-option v-for="item in examServiceList" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="类型" v-if="startForm.status == '训练' && [32].indexOf(user.group_id) >= 0">
          <el-select v-model="startForm.exam_service">
            <el-option v-for="item in examServiceList" :key="item.value" :label="item.value" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务员" v-if="startForm.status == '训练' && salesList.length > 1">
          <el-select
            v-model="startForm.sales_id"
            filterable
            remote
            reserve-keyword
            placeholder="输入业务员姓名或拼音"
            :remote-method="searchSales"
            :loading="salesLoading">
            <el-option
              v-for="item in salesList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="学员人数" v-if="startForm.status == '训练'">
          <el-select v-model="startForm.student_count_type" style="width:140px;">
            <el-option label="登记身份证" value="0"></el-option>
            <el-option label="直接填人数" value="1"></el-option>
          </el-select>
          <el-input-number v-model.number="startForm.student_count" :min="1" :max="10" style="width:120px;" v-if="startForm.student_count_type === '1'"></el-input-number>
          <span v-if="startForm.student_count_type === '1'">人</span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="startForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="startCommit" :loading="startCommiting">确定用车</el-button>
        <el-button @click="startFormVisible = false">取 消</el-button>
      </div>
    </el-dialog>

    <!-- 学员信息窗口 -->
    <el-dialog title="学员信息" :visible.sync="studentDialogVisible" width="960px" @close="handleStudentDialogClose">
      <div v-if="studentLoading" style="height:100px;text-align:center;">正在加载学员信息...</div>
      <el-table v-if="!studentLoading" :data="studentList">
        <el-table-column prop="name" label="姓名"></el-table-column>
        <el-table-column prop="idcard" label="身份证号"></el-table-column>
        <el-table-column v-if="useGateStudentFlow" label="照片" width="90">
          <template slot-scope="scope">
            <img v-if="scope.row.photo_url" :src="scope.row.photo_url" class="student-photo" />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column v-if="useGateStudentFlow" prop="gate_auth_status" label="授权状态" width="100"></el-table-column>
        <el-table-column v-if="useGateStudentFlow" prop="gate_auth_end_time" label="到期时间" width="160"></el-table-column>
        <el-table-column v-if="useGateStudentFlow" prop="gate_auth_error" label="失败原因" min-width="160"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="useGateStudentFlow && scope.row.gate_auth_id"
              type="text"
              :loading="scope.row.gate_auth_loading"
              @click="deleteStudentAuth(scope.row)">
              删除授权
            </el-button>
            <el-button type="text" style="color:#f56c6c;" @click="delStudent(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- group_id===33: 从闸机学员登记中选择 -->
      <div v-if="useGateStudentFlow && !studentLoading" style="margin-top:30px;">
        <div style="margin-bottom:10px;display:flex;align-items:center;justify-content:space-between;">
          <span style="font-weight:bold;">从学员登记中选择</span>
          <div>
            <el-input
              v-model="gateRegisterQuery"
              placeholder="搜索姓名或身份证号"
              clearable
              prefix-icon="el-icon-search"
              style="width:240px;margin-right:10px;"
              @input="filterGateRegisterList">
            </el-input>
            <el-select
              v-model="gateRegisterCarType"
              clearable
              placeholder="培训车型"
              style="width:120px;margin-right:10px;"
              @change="filterGateRegisterList">
              <el-option label="C1" value="C1"></el-option>
              <el-option label="C2" value="C2"></el-option>
            </el-select>
            <el-button type="primary" :loading="gateRegisterAdding" :disabled="gateRegisterSelected.length === 0" @click="addGateRegisterStudents">
              添加选中学员 ({{ gateRegisterSelected.length }})
            </el-button>
          </div>
        </div>
        <el-table
          :data="gateRegisterListFiltered"
          v-loading="gateRegisterLoading"
          @selection-change="handleGateRegisterSelection"
          @sort-change="handleGateRegisterSortChange"
          ref="gateRegisterTable"
          max-height="360"
          size="small">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="student_name" label="姓名" width="100"></el-table-column>
          <el-table-column prop="idcard" label="身份证号" min-width="180"></el-table-column>
          <el-table-column prop="car_type" label="培训车型" width="90" sortable="custom"></el-table-column>
          <el-table-column prop="school_name" label="驾校" width="120" sortable="custom"></el-table-column>
          <el-table-column prop="coach_name" label="教练" width="100" sortable="custom"></el-table-column>
          <el-table-column label="照片" width="70">
            <template slot-scope="scope">
              <img v-if="scope.row.face_photo_url" :src="scope.row.face_photo_url" class="student-photo" />
              <span v-else>-</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 非 group_id===33: 手动录入 -->
      <el-form :model="studentForm" ref="studentForm" :rules="studentFormRules" label-width="120px" v-if="!useGateStudentFlow && !studentLoading" style="margin-top:50px;">
        <el-form-item label="姓名" prop="name">
          <el-input v-model="studentForm.name"></el-input>
        </el-form-item>
        <el-form-item label="身份证号" prop="idcard">
          <el-input v-model="studentForm.idcard"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addStudent" :loading="studentAdding">添加学员</el-button>
          <el-button @click="readIdcard" :loading="studentAdding">读身份证</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 结算窗口 -->
    <pay-dialog :visible="payDialogVisible" :user="user" :bill-id="billId" @confirm="payConfirm" @cancel="payCancel"></pay-dialog>
  </div>
</template>

<script>
import PayDialog from './PayDialog'
import ListFunc from '../../mixins/ListFunc'
import _ from 'lodash'
export default {
  mixins: [ListFunc],
  props: {
    user: Object
  },
  components: {
    PayDialog
  },
  data () {
    return {
      pageSize: 0,
      sqlcode: 'charge_list',
      companyList: [],
      searchForm: {
        company_ids: [],
        query: ''
      },
      statusFilters: [
        { text: '闲置', value: '闲置' },
        { text: '训练', value: '训练' },
        { text: '考试', value: '考试' },
        { text: '牵车', value: '牵车' },
        { text: '试车', value: '试车' },
        { text: '热车', value: '热车' },
        { text: '加油', value: '加油' },
        { text: '维修', value: '维修' },
        { text: '洗车', value: '洗车' },
        { text: '培训', value: '培训' }
      ],
      timer: null,
      timerAutoStop: null,
      coachList: [{
        value: 0,
        label: '无'
      }],
      coachLoading: false,
      secuList: [],
      secuLoading: false,
      salesList: [],
      salesLoading: false,
      startFormVisible: false,
      startFormTitle: '开始用车',
      startForm: {
        id: 0,
        company_id: 0,
        status: '训练',
        student_count_type: '0',
        student_count: 0,
        secu_id: 0,
        coach_id: 0,
        min_fee: 0,
        fee: 0,
        yajing: 0,
        route_name: '路线1',
        sales_id: 0,
        exam_service: null,
        remark: '',
        auto_stop_minutes: 0,
        fee_package_id: 0,
        fee_package_count: 1,
        is_prepaid: '0'
      },
      feePackageList: [],
      autoStop: false,
      startCommiting: false,
      batStarting: false,
      batEnding: false,
      studentDialogVisible: false,
      studentList: [],
      studentLoading: false,
      studentAdding: false,
      studentCameraLoading: false,
      studentStream: null,
      studentStreamActive: false,
      studentPhotoBlob: null,
      studentPhotoPreview: '',
      studentForm: {
        company_id: 0,
        car_id: 0,
        name: '',
        idcard: ''
      },
      studentFormRules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ]
      },
      gateRegisterList: [],
      gateRegisterLoading: false,
      gateRegisterSelected: [],
      gateRegisterQuery: '',
      gateRegisterCarType: '',
      gateRegisterSortField: '',
      gateRegisterSortOrder: '',
      gateRegisterAdding: false,
      payDialogVisible: false,
      billId: 0,
      selectRow: {},
      todayTotal: {
        total: 0,
        cash: 0,
        alipay: 0,
        wechat: 0,
        balance: 0,
        coupon: 0,
        virtual: 0
      },
      examServiceList: []
    }
  },
  computed: {
    defFeeLabel() {
      if (this.selectRow.price_type === '按分钟计费') {
        return `计时收费:${this.selectRow.price_m}元/分钟`
      } else if (this.selectRow.price_type === '按小时计费') {
        return `计时收费:${this.selectRow.price_h}元/小时`
      }
      return '计时收费'
    },
    selectedPackage() {
      return this.feePackageList.find(r => r.id === this.startForm.fee_package_id)
    },
    showBatchButtons () {
      if (this.selectRows.length > 0) {
        let s = this.selectRows[0].status
        if (s === '训练') {
          return false
        }
        for (let i = 1; i < this.selectRows.length; i++) {
          if (s !== this.selectRows[i].status) {
            return false
          }
        }
        return true
      }
      return false
    },
    batchStatus () {
      if (this.selectRows.length > 0) {
        return this.selectRows[0].status
      }
      return ''
    },
    startFormRules () {
      if (this.startForm.status === '训练') {
        return {
          coach_id: [
            { required: true, message: '请选择教练', trigger: 'blur' }
          ],
          secu_id: [
            { required: true, message: '请选择安全员', trigger: 'blur' }
          ]
        }
      } else {
        return {}
      }
    },
    autoStopFee () {
      if (this.selectRow.price_type === '按分钟计费') {
        return Math.ceil(this.startForm.auto_stop_minutes * this.selectRow.price_m)
      } else if (this.selectRow.price_type === '按小时计费') {
        return Math.ceil(this.startForm.auto_stop_minutes/60) * this.selectRow.price_h
      }
      return 0
    },
    totalYajing () {
      let yj = 0
      for (let i = 0; i < this.list.length; i++) {
        yj += this.list[i].yajing
      }
      return yj
    },
    secuListFilter () {
      return this.secuList.filter(r => (r.company_id === 0 || r.company_id === this.selectRow.company_id))
    },
    feePackageListFilter () {
      return this.feePackageList.filter(r => (r.company_id === 0 || r.company_id === this.selectRow.company_id))
    },
    useGateStudentFlow () {
      return this.user && this.user.group_id === 33
    },
    gateRegisterListFiltered () {
      return this.gateRegisterList.filter(r => {
        const matchQuery = !this.gateRegisterQuery ||
          (r.student_name && r.student_name.toLowerCase().indexOf(this.gateRegisterQuery.toLowerCase()) >= 0) ||
          (r.idcard && r.idcard.toLowerCase().indexOf(this.gateRegisterQuery.toLowerCase()) >= 0)
        const matchCarType = !this.gateRegisterCarType || r.car_type === this.gateRegisterCarType
        return matchQuery && matchCarType
      })
    }
  },
  watch: {
    autoStop (val) {
      if (this.startForm.fee_package_id <= 0) {
        this.startForm.auto_stop_minutes = val ? 60 : 0
      }
    }
  },
  mounted () {
    this.fetchCompanyList()
    this.fetchSecuList()
    this.fetchSalesList()
    this.fetchTodayTotal()
    this.fetchFeePackageList()
    this.fetchExamServiceList()
    this.timer = setInterval(() => {
      this.refresh()
    }, 10 * 1000)
    this.timerAutoStop = setInterval(() => {
      this.checkAutoStop()
    }, 60 * 1000)
    this.checkSimExDate()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timerAutoStop) {
      clearInterval(this.timerAutoStop)
    }
  },
  methods: {
    filterStatus (value, row) {
      return row.status ===  value
    },
    tableRowClassName({row, rowIndex}) {
      if (row.status === '闲置') {
        return ''
      } else if (row.status === '训练') {
        return 'row-green'
      } else {
        return 'row-red'
      }
    },
    fetchCompanyList () { // 获取考场列表
      this.$http.get('/dbapi/company_combo').then(response => {
        if (response.data.success) {
          this.companyList = response.data.list
          this.searchForm.company_ids = this.companyList.map(c => c.value)
        }
      })
    },
    fetchSecuList () {
      this.$http.get(`/dbapi/secu_combo`).then(response => {
        if (response.data.success) {
          this.secuList = response.data.list
        }
      })
    },
    fetchSalesList () {
      this.$http.get('/dbapi/sales_combo').then(response => {
        this.salesLoading = false
        if (response.data.success) {
          this.salesList = response.data.list
        }
      })
    },
    fetchTodayTotal () {
      this.$http.get('/dbapi/today_total').then(response => {
        if (response.data.success && response.data.list.length > 0) {
          this.todayTotal = response.data.list[0]
        }
      })
    },
    fetchFeePackageList () {
      this.$http.get('/dbapi/fee_package_list?status=启用').then(response => {
        if (response.data.success) {
          this.feePackageList = response.data.list
        }
      })
    },
    fetchExamServiceList () {
      this.$http.get('/dbapi/sys_combo_list?name=培训服务').then(response => {
        if (response.data.success) {
          this.examServiceList = response.data.list
        }
      })
    },
    searchCoach: _.debounce( // 搜索教练
      function (query) {
        this.coachLoading = true
        this.$http.get('/dbapi/coach_combo?query=' + query).then(response => {
          this.coachLoading = false
          if (response.data.success) {
            this.coachList = response.data.list
          }
        })
      },
      500
    ),
    searchSecu: _.debounce( // 搜索安全员
      function (query) {
        this.secuLoading = true
        this.$http.get(`/dbapi/secu_combo?company_id=${this.startForm.company_id}&query=${query}`).then(response => {
          this.secuLoading = false
          if (response.data.success) {
            this.secuList = response.data.list
          }
        })
      },
      500
    ),
    searchSales: _.debounce( // 搜索业务员
      function (query) {
        this.salesLoading = true
        this.$http.get(`/dbapi/sales_combo?query=${query}`).then(response => {
          this.salesLoading = false
          if (response.data.success) {
            this.salesList = response.data.list
          }
        })
      },
      500
    ),
    start (row) { // 开始用车
      this.selectRow = row
      this.startFormTitle = `开始用车: ${row.company_name} / ${row.car_alias} / ${row.licnum}`
      this.startForm = {
        id: row.id,
        company_id: row.company_id,
        status: '训练',
        student_count_type: '0',
        student_count: 0,
        secu_id: 0,
        coach_id: 0,
        min_fee: 0,
        fee: 0,
        yajing: 0,
        route_name: '路线1',
        sales_id: 0,
        exam_service: [1,10].indexOf(this.user.group_id)>=0? '4' : null,
        remark: '',
        auto_stop_minutes: 0,
        fee_package_id: 0,
        fee_package_count: 1,
        is_prepaid: this.startForm.is_prepaid
      }
      this.autoStop = false
      this.startFormVisible = true
    },
    startCommit: _.throttle(
      function () {
        this.$refs.startForm.validate((valid) => {
          if (valid) {
            if (this.startForm.fee_package_id <= 0) {
              this.startForm.is_prepaid = '0'
            }
            let url = '/dbapi/start_usecar'
            if (this.startForm.status === '训练') {
              if (this.startForm.is_prepaid === '1') {
                url = '/dbapi/start_train_prepaid'
              } else {
                url = '/dbapi/start_train_2'
              }
            } else if (this.startForm.status === '考试') {
              url = '/dbapi/start_exam'
            }
            this.startCommiting = true
            this.$http.post(url, this.startForm).then(response => {
              this.startCommiting = false
              if (response.data.success) {
                this.startFormVisible = false
                // 发送指令
                if (this.selectRow.device_id && this.selectRow.device_id.length == 11) {
                  this.$message({
                    type: 'info',
                    message: '正在恢复车辆油路...'
                  })
                  this.$http.post('/udp/device/open', {
                    device_id: this.selectRow.device_id
                  }).then(response => {
                    if (response.data.success) {
                      this.$message({
                        type: 'success',
                        message: '车辆油路已恢复'
                      })
                    } else {
                      this.$message({
                        type: 'error',
                        message: '恢复油路操作失败:' + response.data.message
                      })
                    }
                  })
                }
                // 登记学员
                if (this.startForm.status === '训练' && this.startForm.student_count_type === '0') {
                  if (this.startForm.is_prepaid === '1') {
                    this.$http.get('/dbapi/last_bill_id?car_id=' + this.startForm.id).then(response => {
                      if (response.data.success) {
                        if (response.data.list.length > 0) {
                          this.pay(response.data.list[0].id)
                        } else {
                          this.$message({
                            type: 'error',
                            message: '获取账单失败,请在账单记录中结算'
                          })
                        }
                      } else {
                        this.$message({
                          type: 'error',
                          message: '获取账单失败,请在账单记录中结算:' + response.data.message
                        })
                      }
                    })
                  } else {
                    this.$confirm(`是否要现在登记学员信息？`, '提示', {
                      confirmButtonText: '现在登记',
                      cancelButtonText: '稍后登记',
                      type: 'warning'
                    }).then(() => {
                      this.showStudent({ id: this.startForm.id, company_id: this.startForm.company_id })
                    })
                  }
                }
                this.refresh()
              } else {
                this.$message({
                  type: 'error',
                  message: response.data.message
                })
              }
            })
          }
        })
      },
      2000
    ),
    stop: _.throttle( // 结束用车
      function (row) {
        this.$confirm(`确定要结束用车吗？${row.company_name} / ${row.car_alias} / ${row.licnum}`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let url = '/dbapi/stop_usecar'
          if (row.status == '训练') {
            url = '/dbapi/stop_train_2'
          }
          this.$http.post(url, {
            id: row.id,
            bill_id: row.bill_id
          }).then(response => {
            if (response.data.success) {
              // 发送熄火指令
              if (row.device_id && row.device_id.length == 11) {
                this.$message({
                  type: 'info',
                  message: '正在关闭车辆油路...'
                })
                this.$http.post('/udp/device/close', {
                  device_id: row.device_id
                }).then(response => {
                  if (response.data.success) {
                    this.$message({
                      type: 'success',
                      message: '车辆油路已断开'
                    })
                  } else {
                    this.$message({
                      type: 'error',
                      message: '切断油路操作失败:' + response.data.message
                    })
                  }
                })
              }
              // 获取账单信息,打开账单窗口
              if (row.status == '训练' && row.is_prepaid !== '1') {
                this.$http.get('/dbapi/last_bill_id?car_id=' + row.id).then(response => {
                  if (response.data.success) {
                    if (response.data.list.length > 0) {
                      this.pay(response.data.list[0].id)
                    } else {
                      this.$message({
                        type: 'error',
                        message: '获取账单失败,请稍后在账单记录中结算'
                      })
                    }
                  } else {
                    this.$message({
                      type: 'error',
                      message: '获取账单失败,请稍后在账单记录中结算:' + response.data.message
                    })
                  }
                })
              }
              this.refresh()
            } else {
              this.$message({
                type: 'error',
                message: response.data.message
              })
            }
          })
        })
      },
      1000
    ),
    showStudent (row) { // 显示学员窗口
      this.studentDialogVisible = true
      this.studentForm.car_id = row.id
      this.studentForm.company_id = row.company_id
      this.fetchStudentList().then(() => {
        if (this.useGateStudentFlow) {
          this.fetchGateRegisterList()
        }
      })
    },
    async fetchStudentList () { // 读取学员列表
      this.studentLoading = true
      let authResponse = { data: { success: false, list: [] } }
      if (this.useGateStudentFlow) {
        authResponse = await this.$http.get('/gate/auth/list', {
          params: {
            car_id: this.studentForm.car_id
          }
        }).catch(() => ({ data: { success: false, list: [] } }))
      }
      return this.$http.get('/dbapi/student_list?bill_id=0&car_id=' + this.studentForm.car_id).then(response => {
        this.studentLoading = false
        if (response.data.success) {
          this.studentList = this.useGateStudentFlow ? this.mergeStudentAuthList(response.data.list, authResponse.data.list || []) : response.data.list
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    addStudent () { // 添加学员（非闸机流程）
      this.$refs.studentForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        this.studentAdding = true
        try {
          const response = await this.$http.post('/dbapi/insert_student_car', this.studentForm)
          if (!response.data.success) {
            throw new Error(response.data.message)
          }
          this.$refs.studentForm.resetFields()
          await this.fetchStudentList()
        } catch (e) {
          this.$message({
            type: 'error',
            message: e.message || '添加学员失败'
          })
        } finally {
          this.studentAdding = false
        }
      })
    },
    readIdcard () { // 读身份证（非闸机流程）
      this.studentAdding = true
      this.$idcard.read().then(data => {
        return this.$http.post('/dbapi/insert_student_car', {
          car_id: this.studentForm.car_id,
          company_id: this.studentForm.company_id,
          name: data.name,
          idcard: data.code
        }).then(response => {
          if (response.data.success) {
            this.fetchStudentList()
          } else {
            this.$message({
              type: 'error',
              message: response.data.message
            })
          }
        })
      }).catch(() => {
      }).then(() => {
        this.studentAdding = false
      })
    },
    delStudent (row) {
      this.$confirm(`确定删除学员 ${row.name} 吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        if (this.useGateStudentFlow && row.gate_auth_id) {
          await this.$http.post('/gate/face/delete', {
            auth_id: row.gate_auth_id
          })
        }
        const response = await this.$http.post('/dbapi/del_student_car', {
          id: row.id
        })
        if (response.data.success) {
          // 重置分车状态为未分车
          if (this.useGateStudentFlow && row.idcard) {
            await this.$http.post('/gate/student-register/car-status', {
              idcard: row.idcard,
              car_status: '未分车'
            }).catch(() => {})
          }
          this.fetchStudentList()
          if (this.useGateStudentFlow) {
            this.fetchGateRegisterList()
          }
          this.refresh()
        }
      })
    },
    mergeStudentAuthList (studentList, authList) {
      const authMap = {}
      for (let i = 0; i < authList.length; i++) {
        if (!authMap[authList[i].student_id]) {
          authMap[authList[i].student_id] = authList[i]
        }
      }
      return studentList.map(item => {
        const auth = authMap[item.id]
        return Object.assign({}, item, {
          gate_auth_id: auth ? auth.id : 0,
          gate_auth_status: auth ? this.formatGateAuthStatus(auth) : '未授权',
          gate_auth_end_time: auth ? auth.auth_end_time : '',
          gate_auth_error: auth ? auth.last_error : '',
          gate_auth_loading: false,
          photo_url: item.face_photo_url || (auth ? auth.photo_url : '')
        })
      })
    },
    formatGateAuthStatus (row) {
      if (!row) {
        return '未授权'
      }
      if (row.sync_status === 'success') {
        return '已授权'
      }
      if (row.sync_status === 'waiting_device') {
        return '待补授权'
      }
      if (['pending', 'syncing', 'deleting'].indexOf(row.sync_status) >= 0) {
        return '处理中'
      }
      if (row.sync_status === 'deleted' || row.status === 'deleted') {
        return '已删除'
      }
      if (row.last_error) {
        return '失败'
      }
      return row.status || '未授权'
    },
    openStudentCamera (options = {}) {
      const { silent = false } = options
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        if (!silent) {
          this.$message({
            type: 'error',
            message: '当前浏览器不支持摄像头'
          })
        }
        return
      }
      this.studentCameraLoading = true
      this.stopStudentCamera()
      navigator.mediaDevices.getUserMedia({
        video: {
          width: { ideal: 1280 },
          height: { ideal: 720 },
          facingMode: 'user'
        },
        audio: false
      }).then(stream => {
        this.studentStream = stream
        this.studentStreamActive = true
        this.$nextTick(() => {
          if (this.$refs.studentCameraVideo) {
            this.$refs.studentCameraVideo.srcObject = stream
          }
        })
      }).catch(() => {
        if (!silent) {
          this.$message({
            type: 'error',
            message: '打开摄像头失败，请检查浏览器权限'
          })
        }
      }).then(() => {
        this.studentCameraLoading = false
      })
    },
    captureStudentPhoto () {
      const video = this.$refs.studentCameraVideo
      const canvas = this.$refs.studentCameraCanvas
      if (!video || !canvas || !video.videoWidth || !video.videoHeight) {
        this.$message({
          type: 'warning',
          message: '摄像头尚未就绪'
        })
        return
      }
      const size = 720
      const side = Math.min(video.videoWidth, video.videoHeight)
      const sx = Math.floor((video.videoWidth - side) / 2)
      const sy = Math.floor((video.videoHeight - side) / 2)
      canvas.width = size
      canvas.height = size
      const ctx = canvas.getContext('2d')
      ctx.drawImage(video, sx, sy, side, side, 0, 0, size, size)
      this.canvasToCompressedBlob(canvas).then(blob => {
        this.clearStudentPreviewUrl()
        this.studentPhotoBlob = blob
        this.studentPhotoPreview = URL.createObjectURL(blob)
      })
    },
    canvasToCompressedBlob (canvas) {
      return new Promise((resolve, reject) => {
        const tryQuality = (quality) => {
          canvas.toBlob(blob => {
            if (!blob) {
              reject(new Error('拍照失败'))
              return
            }
            if (blob.size <= 450 * 1024 || quality <= 0.4) {
              resolve(blob)
            } else {
              tryQuality(quality - 0.1)
            }
          }, 'image/jpeg', quality)
        }
        tryQuality(0.92)
      })
    },
    clearStudentPreviewUrl () {
      if (this.studentPhotoPreview) {
        URL.revokeObjectURL(this.studentPhotoPreview)
      }
      this.studentPhotoPreview = ''
    },
    clearStudentCapture () {
      this.clearStudentPreviewUrl()
      this.studentPhotoBlob = null
    },
    stopStudentCamera () {
      if (this.studentStream) {
        this.studentStream.getTracks().forEach(track => track.stop())
        this.studentStream = null
      }
      this.studentStreamActive = false
    },
    async uploadStudentPhoto () {
      const formData = new FormData()
      formData.append('file', this.studentPhotoBlob, `${this.studentForm.idcard || 'student'}-${Date.now()}.jpg`)
      const response = await this.$http.post('/api/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      if (!response.data.success) {
        throw new Error(response.data.message || '照片上传失败')
      }
      return response.data.url
    },
    deleteStudentAuth (row) {
      row.gate_auth_loading = true
      this.$http.post('/gate/face/delete', {
        auth_id: row.gate_auth_id
      }).then(response => {
        row.gate_auth_loading = false
        if (response.data.success) {
          this.$message({
            type: 'success',
            message: response.data.message
          })
          this.fetchStudentList()
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      }).catch(() => {
        row.gate_auth_loading = false
      })
    },
    resetStudentFormFields () {
      const carId = this.studentForm.car_id
      const companyId = this.studentForm.company_id
      this.studentForm = {
        company_id: companyId,
        car_id: carId,
        name: '',
        idcard: ''
      }
    },
    handleStudentDialogClose () {
      if (this.useGateStudentFlow) {
        this.stopStudentCamera()
        this.clearStudentCapture()
        this.gateRegisterList = []
        this.gateRegisterSelected = []
        this.gateRegisterQuery = ''
        this.gateRegisterCarType = ''
      }
      this.resetStudentFormFields()
    },
    async fetchGateRegisterList () { // 获取闸机学员登记列表（仅未分车）
      this.gateRegisterLoading = true
      try {
        const response = await this.$http.get('/gate/student-register', {
          params: {
            company_id: this.studentForm.company_id,
            car_status: '未分车',
            sort_field: this.gateRegisterSortField,
            sort_order: this.gateRegisterSortOrder,
            page: 1,
            page_size: 9999
          }
        })
        if (response.data.success) {
          this.gateRegisterList = response.data.list || []
        } else {
          this.$message({
            type: 'error',
            message: response.data.message || '获取学员登记列表失败'
          })
        }
      } catch (e) {
        this.$message({
          type: 'error',
          message: '获取学员登记列表失败'
        })
      } finally {
        this.gateRegisterLoading = false
      }
    },
    handleGateRegisterSelection (rows) {
      this.gateRegisterSelected = rows
    },
    handleGateRegisterSortChange ({ prop, order }) {
      this.gateRegisterSortField = order ? prop : ''
      this.gateRegisterSortOrder = order === 'ascending' ? 'asc' : order === 'descending' ? 'desc' : ''
      this.fetchGateRegisterList()
    },
    filterGateRegisterList () {
      // 搜索时清除选中状态
      this.gateRegisterSelected = []
      if (this.$refs.gateRegisterTable) {
        this.$refs.gateRegisterTable.clearSelection()
      }
    },
    async addGateRegisterStudents () { // 批量添加选中的闸机学员
      if (this.gateRegisterSelected.length === 0) {
        return
      }
      this.gateRegisterAdding = true
      let successCount = 0
      let failMessages = []
      try {
        for (const student of this.gateRegisterSelected) {
          try {
            const response = await this.$http.post('/dbapi/insert_student_car', {
              car_id: this.studentForm.car_id,
              company_id: this.studentForm.company_id,
              name: student.student_name,
              idcard: student.idcard
            })
            if (!response.data.success) {
              failMessages.push(`${student.student_name}: ${response.data.message}`)
              continue
            }
            // 如果有照片，自动做闸机授权
            if (student.face_photo_url) {
              const authResponse = await this.$http.post('/gate/rent/auth-by-idcard', {
                idcard: student.idcard,
                car_id: this.studentForm.car_id,
                company_id: this.studentForm.company_id,
                photo_url: student.face_photo_url
              })
              if (!authResponse.data.success) {
                failMessages.push(`${student.student_name}: 授权失败 - ${authResponse.data.message}`)
              }
            }
            // 更新分车状态为已分车
            await this.$http.post('/gate/student-register/car-status', {
              idcard: student.idcard,
              car_status: '已分车'
            }).catch(() => {})
            successCount++
          } catch (e) {
            failMessages.push(`${student.student_name}: ${e.message || '添加失败'}`)
          }
        }
        if (successCount > 0) {
          this.$message({
            type: 'success',
            message: `成功添加 ${successCount} 名学员`
          })
        }
        if (failMessages.length > 0) {
          this.$message({
            type: 'warning',
            message: failMessages.join('；'),
            duration: 5000
          })
        }
        this.gateRegisterSelected = []
        await this.fetchStudentList()
        await this.fetchGateRegisterList()
        this.refresh()
      } catch (e) {
        this.$message({
          type: 'error',
          message: e.message || '批量添加学员失败'
        })
      } finally {
        this.gateRegisterAdding = false
      }
    },
    batStart (command) { // 批量开始用车
      this.batStarting = true
      let url = '/dbapi/bat_start'
      if (command === '考试') {
        url = '/dbapi/bat_start_exam'
      }
      this.$http.post(url, {
        ids: this.selectRows.map(r => r.id),
        status: command
      }).then(response => {
        this.batStarting = false
        if (response.data.success) {
          let device_ids = this.selectRows.filter(r => r.device_id).map(r => r.device_id)
          if (device_ids.length > 0) {
            this.$http.post('/udp/device/open', {
              device_id: device_ids
            })
          }
          this.$refs.chargeList.clearSelection()
          this.refresh()
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    batEnd () { // 批量结束用车
      this.batEnding = true
      this.$http.post('/dbapi/bat_end', {
        ids: this.selectRows.map(r => r.id),
        status: this.batchStatus
      }).then(response => {
        this.batEnding = false
        if (response.data.success) {
          let device_ids = this.selectRows.filter(r => r.device_id).map(r => r.device_id)
          if (device_ids.length > 0) {
            this.$http.post('/udp/device/close', {
              device_id: device_ids
            })
          }
          this.$refs.chargeList.clearSelection()
          this.refresh()
          this.$message({
            type: 'success',
            message: '操作成功'
          })
        } else {
          this.$message({
            type: 'error',
            message: response.data.message
          })
        }
      })
    },
    pay (billId) {
      this.billId = billId
      this.payDialogVisible = true
    },
    payConfirm (obj) {
      this.payDialogVisible = false
      this.$confirm('是否要现在打印收据?', '提示', {
        confirmButtonText: '现在打印',
        cancelButtonText: '稍后打印',
        type: 'warning'
      }).then(() => {
        if (obj.start_time === obj.end_time) {
          window.open(this.$http.receiptBaseUrl + '/bill_print_prepaid?id=' + obj.id + '&token=' + localStorage.getItem('kaochang.token'))
        } else {
          // if (obj.pay_total == obj.pay_coupon && this.user.group_id == 2) {
          //   window.open(this.$http.receiptBaseUrl + '/bill_print_coupon?id=' + obj.id + '&token=' + localStorage.getItem('kaochang.token'))
          // } else {
            window.open(this.$http.receiptBaseUrl + '/bill_print?id=' + obj.id + '&token=' + localStorage.getItem('kaochang.token'))
          // }
        }
      })
      this.fetchTodayTotal()
    },
    payCancel () {
      this.payDialogVisible = false
    },
    playNotificationBeep () {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext
        if (!AudioContext) return
        const ctx = new AudioContext()
        const beep = (freq, start, duration) => {
          const osc = ctx.createOscillator()
          const gain = ctx.createGain()
          osc.connect(gain)
          gain.connect(ctx.destination)
          osc.frequency.value = freq
          osc.type = 'sine'
          gain.gain.setValueAtTime(0.6, ctx.currentTime + start)
          gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + start + duration)
          osc.start(ctx.currentTime + start)
          osc.stop(ctx.currentTime + start + duration)
        }
        beep(880, 0, 0.2)
        beep(660, 0.25, 0.2)
        beep(880, 0.5, 0.3)
      } catch (e) {}
    },
    checkAutoStop () {
      let notified = false
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].status === '训练' && this.list[i].auto_stop_minutes > 0) {
          let m = this.list[i].auto_stop_minutes - this.list[i].use_time
          if (this.list[i].company_id == 7) {
            if (m <= 3) {
              this.$notify({
                title: '请注意',
                message: `${this.list[i].company_name} ${this.list[i].car_alias} 将在 ${m} 分钟后自动结束`,
                type: 'warning'
              })
              notified = true
            }
          } else if ([1,2,16,40].indexOf(this.list[i].company_id) >= 0) {
            if (m <= 5) {
              this.$notify({
                title: '请注意',
                message: `${this.list[i].company_name} ${this.list[i].car_alias}(${this.list[i].licnum}) 将在 ${m} 分钟后自动结束`,
                type: 'warning'
              })
              notified = true
            }
          } else if ([51,52].indexOf(this.list[i].company_id) >= 0) {
            if (m <= 3) {
              this.$notify({
                title: '请注意',
                message: `${this.list[i].company_name} ${this.list[i].car_alias}(${this.list[i].licnum}) 将在 ${m} 分钟后自动结束`,
                type: 'warning'
              })
              notified = true
            }
          } else {
            if ([20, 10, 5, 1].indexOf(m) >= 0) {
              this.$notify({
                title: '请注意',
                message: `${this.list[i].company_name} ${this.list[i].car_alias} 将在 ${m} 分钟后自动结束`,
                type: 'warning'
              })
              notified = true
            }
          }
        }
      }
      if (notified) {
        this.playNotificationBeep()
      }
    },
    feePackageChange (val) {
      this.startForm.fee_package_count = 1
      if (val <= 0) {
        this.startForm.min_fee = 0
        this.startForm.fee = 0
        this.autoStop = false
        this.startForm.auto_stop_minutes = 0
      } else {
        let f = this.feePackageList.filter(r => r.id === val)
        if (f.length > 0) {
          f = f[0]
        } else {
          return
        }
        if (f.type == '按分钟计费') {
          this.startForm.min_fee = 0
          this.startForm.fee = 0
          this.autoStop = false
          this.startForm.auto_stop_minutes = 0
        } else {
          this.startForm.min_fee = f.fee
          this.startForm.fee = f.fee
          this.autoStop = true
          this.startForm.auto_stop_minutes = f.max_time
          if (f.exam_service) {
            this.startForm.exam_service = f.exam_service
          }
        }
      }
    },
    feePackageCountChange (val) {
      let f = this.feePackageList.filter(r => r.id === this.startForm.fee_package_id)
      if (f.length > 0) {
        f = f[0]
      } else {
        return
      }
      this.startForm.min_fee = f.fee * val
      this.startForm.fee = f.fee * val
      this.startForm.auto_stop_minutes = f.max_time * val
    },
    printUse (row) {
      if (row.bill_id > 0) {
        window.open(this.$http.receiptBaseUrl + '/bill_print_prepaid?id=' + row.bill_id + '&token=' + localStorage.getItem('kaochang.token'))
      } else {
        window.open(this.$http.receiptBaseUrl + '/use_print?id=' + row.id + '&token=' + localStorage.getItem('kaochang.token'))
      }
    },
    gotoReportOper () {
      this.$router.push('/report/oper')
    },
    addCoach () {
      this.$router.push('/coach/new')
    },
    checkSimExDate () {
      this.$http.get('/dbapi/sim_ex_date').then(response => {
        if (response.data.success) {
          let list = response.data.list
          if (list.length > 0) {
            const h = this.$createElement
            let listDiv = []
            for (let i = 0; i < list.length; i++) {
              listDiv.push(h('div', null, `${list[i].company_name}/${list[i].licnum}/流量卡号:${list[i].phone}/到期日期:${list[i].sim_ex_date}`))
            }
            this.$msgbox({
              title: '!!!流量费到期提醒!!!',
              message: h('div', null, [
                h('div', null, [
                  h('span', null, '您有'),
                  h('b', { style: 'color: red' }, list.length.toString()),
                  h('span', null, '台设备流量费即将到期，请注意！！')
                ]),
                ...listDiv
              ]),
              confirmButtonText: '确定'
            })
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.start-form .el-form-item {
  margin-bottom: 10px;
}

.camera-panel {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 12px;
}

.camera-preview {
  width: 320px;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #f5f7fa;
  border-radius: 4px;
}

.camera-preview video,
.student-photo-preview {
  width: 320px;
  height: 240px;
  object-fit: cover;
}

.camera-actions {
  margin-top: 10px;
}

.camera-tip {
  margin-top: 8px;
  color: #909399;
  line-height: 20px;
}

.camera-empty {
  color: #909399;
}

.student-photo {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  object-fit: cover;
  border: 1px solid #dcdfe6;
}
</style>



// WEBPACK FOOTER //
// src/components/rent/Charge.vue